import { useContext } from 'react';
import { Button, Link, Dialog, DialogBody, DialogFooter, useDisclosure } from '@bitrise/bitkit';
import { planSelectorPagePath } from '@/utils/monolithApiRouteService';
import { GlobalPropsContext } from '@/components/page/GlobalPropsContext';
import { GlobalPropsWithAccount } from '@/models/GlobalProps';
import { useMutateUserMetadata } from '@/hooks/api/useUserMetadata';

const TimeBasedTrialDialog = () => {
  const { isOpen, onClose } = useDisclosure({ defaultIsOpen: true });

  const { account } = useContext(GlobalPropsContext) as GlobalPropsWithAccount;

  const { mutate } = useMutateUserMetadata({ transform: false });

  if (!account || !account.timeBasedTrial || !account.timeBasedTrial.showXDaysUntilTrialEndModal) {
    return null;
  }

  const onDialogClose = () => {
    mutate({ [`time_based_trial_x_days_from_trial_modal_closed_on_${account.slug}`]: true });
    onClose();
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onDialogClose}
      title={`${account.timeBasedTrial?.xDaysUntilTrialEnd} days left in your trial`}
    >
      <DialogBody>
        The 30 day free trial for your workspace is almost up, with only {account.timeBasedTrial?.xDaysUntilTrialEnd}{' '}
        days left. Select a plan and subscribe to continue using Bitrise after the trial ends.
      </DialogBody>
      <DialogFooter>
        <Link
          colorScheme="purple"
          href="https://www.bitrise.io/contact"
          isExternal
          marginInlineStart="16"
          marginInlineEnd="auto"
        >
          Contact us
        </Link>
        <Button as="a" href={planSelectorPagePath(account.slug)}>
          Select plan
        </Button>
      </DialogFooter>
    </Dialog>
  );
};

export default TimeBasedTrialDialog;
